import type { HomePageData } from '@/types/home'
import { mockProperties } from './properties'

const verified = mockProperties.filter((p) => p.isVerified)

export const mockHomeData: HomePageData = {
  premiumProjects: verified.slice(0, 8),
  recommendedForSale: verified.filter((p) => p.intent === 'buy').slice(0, 8),
  recommendedForRent: verified.filter((p) => p.intent === 'rent').slice(0, 8),
  freshProjectSlides: [
    {
      id: 1,
      image: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1400&h=560&fit=crop&q=80',
      alt: 'Luxury apartments in Rajkot',
      href: '/property-for-sale-in-rajkot',
    },
    {
      id: 2,
      image: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=1400&h=560&fit=crop&q=80',
      alt: 'New villa project launch',
      href: '/villas-for-sale-in-ahmedabad',
    },
    {
      id: 3,
      image: 'https://images.unsplash.com/photo-1512917774080-9991f1c4c750?w=1400&h=560&fit=crop&q=80',
      alt: 'Premium residential project',
      href: '/properties-in-ahmedabad?premium=true',
    },
    {
      id: 4,
      image: 'https://images.unsplash.com/photo-1605276374104-dee2a0ed3cd6?w=1400&h=560&fit=crop&q=80',
      alt: 'Commercial spaces in Ahmedabad',
      href: '/properties-in-ahmedabad?intent=commercial',
    },
    {
      id: 5,
      image: 'https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=1400&h=560&fit=crop&q=80',
      alt: 'Ready to move flats',
      href: '/apartments-for-sale-in-ahmedabad',
    },
    {
      id: 6,
      image: 'https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?w=1400&h=560&fit=crop&q=80',
      alt: 'New launch in Surat',
      href: '/property-for-sale-in-surat',
    },
  ],
  popularCities: [
    { id: 1, name: 'Ahmedabad', slug: 'ahmedabad', image: 'https://images.unsplash.com/photo-1599661046289-e31897846e41?w=800&h=1000&fit=crop&q=80', propertyCount: 4200 },
    { id: 2, name: 'Rajkot', slug: 'rajkot', image: 'https://images.unsplash.com/photo-1582510003544-4d00b7f74220?w=600&h=450&fit=crop&q=80', propertyCount: 1850 },
    { id: 6, name: 'Gandhinagar', slug: 'gandhinagar', image: 'https://images.unsplash.com/photo-1449824913935-59a10b8d2000?w=600&h=450&fit=crop&q=80', propertyCount: 890 },
    { id: 3, name: 'Surat', slug: 'surat', image: 'https://images.unsplash.com/photo-1570168007204-dfb528c6958f?w=600&h=450&fit=crop&q=80', propertyCount: 2100 },
    { id: 4, name: 'Vadodara', slug: 'vadodara', image: 'https://images.unsplash.com/photo-1514565131-fce0801e5785?w=600&h=450&fit=crop&q=80', propertyCount: 1150 },
  ],
  topBuilders: [
    { id: 1, name: 'Adani Realty', logo: 'https://ui-avatars.com/api/?name=AR&background=0F5D9A&color=fff', projectCount: 24 },
    { id: 2, name: 'Shanti Developers', logo: 'https://ui-avatars.com/api/?name=SD&background=1a7fd4&color=fff', projectCount: 18 },
    { id: 3, name: 'Sunrise Group', logo: 'https://ui-avatars.com/api/?name=SG&background=0a4a7d&color=fff', projectCount: 12 },
    { id: 4, name: 'Elite Homes', logo: 'https://ui-avatars.com/api/?name=EH&background=1f5fbf&color=fff', projectCount: 9 },
  ],
  categories: [
    {
      id: 1,
      name: 'Apartments',
      displayName: 'Residential Apartment',
      slug: 'apartments',
      icon: '🏢',
      count: 860,
      image: 'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=600&h=400&fit=crop&q=80',
    },
    {
      id: 2,
      name: 'Villas',
      displayName: 'Independent House/ Villa',
      slug: 'villas',
      icon: '🏡',
      count: 600,
      image: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=600&h=400&fit=crop&q=80',
    },
    {
      id: 3,
      name: 'Plots',
      displayName: 'Residential Land',
      slug: 'plots',
      icon: '📐',
      count: 100,
      image: 'https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=600&h=400&fit=crop&q=80',
    },
    {
      id: 4,
      name: 'Commercial',
      displayName: 'Commercial Property',
      slug: 'commercial',
      icon: '🏬',
      count: 410,
      image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=600&h=400&fit=crop&q=80',
    },
    {
      id: 5,
      name: 'PG / Hostel',
      displayName: 'PG / Hostel',
      slug: 'pg',
      icon: '🛏️',
      count: 180,
      image: 'https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?w=600&h=400&fit=crop&q=80',
    },
  ],
  trendingLocalities: [
    { id: 1, name: 'Satellite', slug: 'satellite', city: 'Ahmedabad', avgPrice: '₹ 5,200/sqft', trend: '+8%', trendUp: true },
    { id: 2, name: 'Bopal', slug: 'bopal', city: 'Ahmedabad', avgPrice: '₹ 4,800/sqft', trend: '+5%', trendUp: true },
    { id: 3, name: 'SG Highway', slug: 'sg-highway', city: 'Ahmedabad', avgPrice: '₹ 6,100/sqft', trend: '+12%', trendUp: true },
    { id: 4, name: 'Gota', slug: 'gota', city: 'Ahmedabad', avgPrice: '₹ 3,900/sqft', trend: '+3%', trendUp: true },
    { id: 5, name: 'Prahlad Nagar', slug: 'prahlad-nagar', city: 'Ahmedabad', avgPrice: '₹ 7,200/sqft', trend: '-2%', trendUp: false },
    { id: 6, name: '150 Ft Ring Rd', slug: '150-ft-ring-road', city: 'Rajkot', avgPrice: '₹ 4,100/sqft', trend: '+6%', trendUp: true },
  ],
  statistics: [
    { label: 'Properties Listed', value: 8445, suffix: '+' },
    { label: 'Cities Covered', value: 120, suffix: '+' },
    { label: 'Happy Customers', value: 111000, suffix: '+' },
    { label: 'Verified Listings', value: 98, suffix: '%' },
  ],
  testimonials: [
    { id: 1, name: 'Rajesh Patel', role: 'Property Buyer', content: 'QBC helped me find my dream home in Satellite within 2 weeks. Verified listings and excellent support throughout the site visit process.', avatar: 'https://ui-avatars.com/api/?name=RP&background=0F5D9A&color=fff', rating: 5 },
    { id: 2, name: 'Priya Shah', role: 'Property Owner', content: 'Listed my 3BHK on QBC and got genuine inquiries within days. The platform is trustworthy, easy to use, and the lead quality is far better than other portals.', avatar: 'https://ui-avatars.com/api/?name=PS&background=1a7fd4&color=fff', rating: 5 },
    { id: 3, name: 'Amit Kumar', role: 'Investor', content: 'Best platform for property discovery in Gujarat. Premium projects section is very helpful for comparing new launches and builder credibility.', avatar: 'https://ui-avatars.com/api/?name=AK&background=0a4a7d&color=fff', rating: 4 },
    { id: 4, name: 'Neha Desai', role: 'First-time Buyer', content: 'As a first-time buyer I was nervous about paperwork. QBC advisors explained RERA, loan options, and shortlisted flats in my budget within a week.', avatar: 'https://ui-avatars.com/api/?name=ND&background=16a34a&color=fff', rating: 5 },
    { id: 5, name: 'Karan Mehta', role: 'Commercial Tenant', content: 'Found office space in Prahlad Nagar through QBC filters. Saved time with accurate sqft, rent, and possession details on every listing.', avatar: 'https://ui-avatars.com/api/?name=KM&background=7c3aed&color=fff', rating: 5 },
    { id: 6, name: 'Sneha Joshi', role: 'Property Seller', content: 'Sold my villa in Bopal in under 45 days. Free listing, professional photos from the premium package, and serious buyers only — highly recommend QBC.', avatar: 'https://ui-avatars.com/api/?name=SJ&background=db2777&color=fff', rating: 5 },
    { id: 7, name: 'Vikram Singh', role: 'NRI Buyer', content: 'Browsing from Dubai was seamless. Virtual tours, WhatsApp updates, and a dedicated manager for my Ahmedabad purchase made the process stress-free.', avatar: 'https://ui-avatars.com/api/?name=VS&background=ea580c&color=fff', rating: 4 },
    { id: 8, name: 'Ananya Reddy', role: 'Rent Seeker', content: 'Shifted to SG Highway for work and found a furnished 2BHK in 3 days. Map search and locality filters on QBC are genuinely useful.', avatar: 'https://ui-avatars.com/api/?name=AR&background=0891b2&color=fff', rating: 5 },
  ],
  showcaseBenefits: [
    {
      id: 1,
      title: 'Professional video shooting',
      description: 'Cinematic property walkthroughs in mobile-friendly format.',
    },
    {
      id: 2,
      title: 'Instagram Reels promotion',
      description: 'Short reels published on QBC social channels for wider reach.',
    },
    {
      id: 3,
      title: 'YouTube client stories',
      description: 'Verified owners share real experiences after premium promotion.',
    },
    {
      id: 4,
      title: 'Multi-channel visibility',
      description: 'Combine app listing, reels, and video for genuine buyer leads.',
    },
  ],
  showcaseVideos: [
    {
      id: 1,
      title: 'Sky Villa · Cinematic Walkthrough',
      subtitle: 'Premium listing · 4K property shoot',
      platform: 'youtube',
      videoId: 'YYWDh8InDOo',
      thumbnail: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=800&h=500&fit=crop&q=80',
      category: 'walkthrough',
      location: 'Rajkot, Gujarat',
      duration: '4:32',
      views: 48200,
      likes: 2100,
      uploadedAt: '2026-04-12',
      propertyHref: '/property-for-sale-in-rajkot',
      builderName: 'Sunrise Group',
    },
    {
      id: 2,
      title: 'Client Success Story',
      subtitle: 'Premium package review',
      platform: 'youtube',
      videoId: '2XXcGtZKa5s',
      thumbnail: 'https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=800&h=500&fit=crop&q=80',
      category: 'review',
      location: 'Ahmedabad',
      duration: '3:18',
      views: 31500,
      likes: 1840,
      uploadedAt: '2026-03-28',
      builderName: 'QBC Premium',
    },
    {
      id: 3,
      title: 'New Launch Reel',
      subtitle: 'Instagram · Quick Build Con',
      platform: 'instagram',
      url: 'https://www.instagram.com/qbc_properties/',
      thumbnail: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1280&h=720&fit=crop&q=80',
      category: 'reel',
      location: 'SG Highway, Ahmedabad',
      duration: '0:45',
      views: 128000,
      likes: 9200,
      uploadedAt: '2026-05-02',
      propertyHref: '/properties-in-ahmedabad?premium=true',
    },
    {
      id: 4,
      title: '3 BHK Apartment Tour',
      subtitle: 'Professional shoot · Ready to move',
      platform: 'youtube',
      videoId: 'LXb3EKWsInQ',
      thumbnail: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=800&h=500&fit=crop&q=80',
      category: 'walkthrough',
      location: 'SG Highway, Ahmedabad',
      duration: '5:06',
      views: 22100,
      likes: 980,
      uploadedAt: '2026-02-14',
      propertyHref: '/properties-in-sg-highway-ahmedabad?intent=buy',
      builderName: 'Elite Homes',
    },
    {
      id: 5,
      title: 'Behind the Reel',
      subtitle: 'Property marketing BTS',
      platform: 'instagram',
      url: 'https://www.instagram.com/qbc_properties/',
      thumbnail: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=1280&h=720&fit=crop&q=80',
      category: 'reel',
      location: 'Surat',
      duration: '0:58',
      views: 86400,
      likes: 6100,
      uploadedAt: '2026-04-20',
    },
    {
      id: 6,
      title: 'Seller Testimonial',
      subtitle: 'Sold in 45 days · Verified owner',
      platform: 'youtube',
      videoId: 'ScMzIvxBSi4',
      thumbnail: 'https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?w=800&h=500&fit=crop&q=80',
      category: 'review',
      location: 'Bopal, Ahmedabad',
      duration: '2:44',
      views: 19300,
      likes: 1120,
      uploadedAt: '2026-01-08',
    },
    {
      id: 7,
      title: 'Builder Vision · Adani Realty',
      subtitle: 'Exclusive launch interview',
      platform: 'youtube',
      videoId: '7Hsonf0QeFs',
      thumbnail: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=800&h=500&fit=crop&q=80',
      category: 'interview',
      location: 'Gift City, Gandhinagar',
      duration: '8:12',
      views: 56700,
      likes: 3200,
      uploadedAt: '2026-03-05',
      builderName: 'Adani Realty',
      propertyHref: '/property-for-sale-in-gandhinagar',
    },
    {
      id: 8,
      title: 'Waterfront Residences Launch',
      subtitle: 'Builder walkthrough · Vadodara',
      platform: 'youtube',
      videoId: 'E7FOmoz8hPU',
      thumbnail: 'https://images.unsplash.com/photo-1512917774080-9991f1c4c750?w=800&h=500&fit=crop&q=80',
      category: 'interview',
      location: 'Vadodara',
      duration: '6:30',
      views: 41200,
      likes: 2450,
      uploadedAt: '2026-02-22',
      builderName: 'Shanti Developers',
      propertyHref: '/property-for-sale-in-vadodara',
    },
  ],
  mapCategories: [
    { id: 'agriculture', label: 'Agriculture', color: '#1f8a4c' },
    { id: 'commercial', label: 'Commercial', color: '#2d9cdb' },
    { id: 'industrial', label: 'Industrial', color: '#e04a3a' },
    { id: 'farm-house', label: 'Farm House', color: '#47d147' },
    { id: 'residential', label: 'Residential', color: '#e0b700' },
    { id: 'na', label: 'NA', color: '#f39c12' },
  ],
  mapProperties: [
    {
      id: 1,
      title: 'Land for Sale in Tekra Kamsoli Tilakwada',
      city: 'Narmada',
      priceLabel: '₹3.11 Cr',
      categoryId: 'agriculture',
      image: 'https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=300&h=180&fit=crop&q=80',
      href: '/property-for-sale-in-vadodara',
      lat: 21.95,
      lng: 73.73,
    },
    {
      id: 2,
      title: 'Premium 4BHK Villa',
      city: 'Ahmedabad',
      priceLabel: '₹2.46 Cr',
      categoryId: 'residential',
      image: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=300&h=180&fit=crop&q=80',
      href: '/property-for-sale-in-ahmedabad',
      lat: 23.0225,
      lng: 72.5714,
    },
    {
      id: 3,
      title: 'Commercial Office Hub',
      city: 'Ahmedabad',
      priceLabel: '₹1.24 Cr',
      categoryId: 'commercial',
      image: 'https://images.unsplash.com/photo-1497366811353-6870744d04b2?w=300&h=180&fit=crop&q=80',
      href: '/properties-in-ahmedabad?intent=commercial',
      lat: 23.03,
      lng: 72.58,
    },
    {
      id: 4,
      title: 'Industrial Plot near Ring Road',
      city: 'Rajkot',
      priceLabel: '₹89 L',
      categoryId: 'industrial',
      image: 'https://images.unsplash.com/photo-1516937941344-00b4e0337589?w=300&h=180&fit=crop&q=80',
      href: '/properties-in-rajkot?intent=commercial',
      lat: 22.3039,
      lng: 70.8022,
    },
    {
      id: 5,
      title: 'Farm House Project',
      city: 'Surat',
      priceLabel: '₹1.52 Cr',
      categoryId: 'farm-house',
      image: 'https://images.unsplash.com/photo-1605276374104-dee2a0ed3cd6?w=300&h=180&fit=crop&q=80',
      href: '/property-for-sale-in-surat',
      lat: 21.1702,
      lng: 72.8311,
    },
    {
      id: 6,
      title: 'NA Plot in Vapi',
      city: 'Vapi',
      priceLabel: '₹72 L',
      categoryId: 'na',
      image: 'https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=300&h=180&fit=crop&q=80',
      href: '/property-for-sale-in-vapi',
      lat: 20.3893,
      lng: 72.9106,
    },
    {
      id: 7,
      title: 'Luxury Apartment Cluster',
      city: 'Vadodara',
      priceLabel: '₹1.07 Cr',
      categoryId: 'residential',
      image: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=300&h=180&fit=crop&q=80',
      href: '/property-for-sale-in-vadodara',
      lat: 22.3072,
      lng: 73.1812,
    },
    {
      id: 8,
      title: 'Agri Land in Bharuch',
      city: 'Bharuch',
      priceLabel: '₹95 L',
      categoryId: 'agriculture',
      image: 'https://images.unsplash.com/photo-1464226184884-fa280b87c399?w=300&h=180&fit=crop&q=80',
      href: '/property-for-sale-in-bharuch',
      lat: 21.7051,
      lng: 72.9959,
    },
  ],
  blogs: [
    { id: 1, title: 'Top 10 Areas to Buy Property in Ahmedabad 2026', slug: 'top-areas-ahmedabad-2026', excerpt: 'Discover the fastest-growing localities with best ROI potential for homebuyers and investors.', image: 'https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=600&h=400&fit=crop&q=80', category: 'Market Trends', publishedAt: '2026-03-01', readingTime: 6 },
    { id: 2, title: 'Home Loan Guide: Everything You Need to Know', slug: 'home-loan-guide', excerpt: 'A complete guide to securing the best home loan rates, eligibility, and documentation in 2026.', image: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=600&h=400&fit=crop&q=80', category: 'Finance', publishedAt: '2026-02-25', readingTime: 8 },
    { id: 3, title: 'RERA Compliance: Why It Matters for Buyers', slug: 'rera-compliance-guide', excerpt: 'Understand RERA regulations and protect your property investment before you sign.', image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=600&h=400&fit=crop&q=80', category: 'Legal', publishedAt: '2026-02-18', readingTime: 5 },
    { id: 4, title: 'Gandhinagar vs Ahmedabad: Where to Invest in 2026', slug: 'gandhinagar-vs-ahmedabad-2026', excerpt: 'Compare price trends, infrastructure, and rental yields across Gujarat\'s top two cities.', image: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=600&h=400&fit=crop&q=80', category: 'Market Trends', publishedAt: '2026-02-12', readingTime: 7 },
    { id: 5, title: 'How to Verify a Property Before Booking', slug: 'verify-property-before-booking', excerpt: 'Checklist for title deeds, encumbrance, builder reputation, and site visit red flags.', image: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=600&h=400&fit=crop&q=80', category: 'Buyers Guide', publishedAt: '2026-02-08', readingTime: 6 },
    { id: 6, title: 'Stamp Duty & Registration in Gujarat Explained', slug: 'stamp-duty-gujarat', excerpt: 'Updated rates, online registration steps, and documents you need at the sub-registrar.', image: 'https://images.unsplash.com/photo-1512917774080-9991f1c4c750?w=600&h=400&fit=crop&q=80', category: 'Legal', publishedAt: '2026-01-30', readingTime: 5 },
    { id: 7, title: 'Renting in Surat: Localities Tenants Love', slug: 'renting-surat-localities', excerpt: 'Best areas for families, IT professionals, and students — with average rent benchmarks.', image: 'https://images.unsplash.com/photo-1605276374104-dee2a0ed3cd6?w=600&h=400&fit=crop&q=80', category: 'Renting', publishedAt: '2026-01-22', readingTime: 4 },
    { id: 8, title: 'Post Property Free: Tips for More Inquiries', slug: 'post-property-free-tips', excerpt: 'Write better titles, add quality photos, and price right to get 3x more leads on QBC.', image: 'https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?w=600&h=400&fit=crop&q=80', category: 'For Owners', publishedAt: '2026-01-15', readingTime: 5 },
  ],
  faqs: [
    { id: 1, question: 'How do I list my property on QBC?', answer: 'Click "Post Property Free" at the top. Fill in your property details across simple steps. Your listing goes live after our verification — usually within 24 hours.' },
    { id: 2, question: 'Are all properties on QBC verified?', answer: 'Yes, our team verifies documents and details for all listings before they go live. Look for the green Verified badge.' },
    { id: 3, question: 'Is there a fee to list properties?', answer: 'Basic listing is completely free. We offer premium packages (starting ₹1,500) for boosted visibility, reel videos, and social promotion.' },
    { id: 4, question: 'How do I schedule a site visit?', answer: 'Click "Book Visit" on any property card. Choose a date and time. Our team will confirm within 2 hours.' },
    { id: 5, question: 'Does QBC work in cities other than Ahmedabad?', answer: 'Yes! We cover Ahmedabad, Rajkot, Surat, Vadodara, Gandhinagar, Jamnagar, and Bhavnagar — with more cities being added.' },
  ],
}
